<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>
          <li>
            <router-link to="/wat-wij-doen"
              ><inline-svg
                src="/images/icons/chevron-right-solid.svg"
              ></inline-svg
              >Wat wij doen</router-link
            >
          </li>
          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Secured printing
          </li>
        </ul>
        <div class="col text">
          <h1>Secured printing</h1>
          <p>
            Wilt u documenten beveiligd laten printen? Dan bent u bij Rijnja aan
            het juiste adres. Wij zijn ISO 27001:2022 gecertificeerd en
            begrijpen dat informatiebeveiliging juist in deze tijd van groot
            belang is. Wij zorgen ervoor dat uw documenten veilig worden geprint
            en bezorgd, zonder dat u daar omkijken naar heeft.
          </p>
          <a class="link-button top-button" href="#contact"
            >Neem contact met ons op</a
          >
          <h2>Veilig een bestelling plaatsen</h2>
          <p>
            Geautoriseerde medewerkers kunnen documenten die vertrouwelijke
            informatie bevatten veilig bestellen via onze website. U uploadt de
            bestanden, stelt de opdracht samen, selecteert een afleveradres en
            plaatst de opdracht. De opdracht wordt vervolgens verwerkt via het
            bestelportal. Omdat de opdracht als “secured printing opdracht” is
            geplaatst, komt deze in ons orderbegeleidingssysteem terecht dat
            volledig is afgeschermd van andere opdrachten.
          </p>
        </div>
        <div class="col image">
          <img class="security" src="@/images/pages/security-3.svg" />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <!--  <section class="row verwerking">

      </section> -->
      <section class="row text-3 stappen">
        <div class="col text">
          <h2>Verwerking van een secured printing document</h2>
          <p>
            Een van onze secured operators controleert de bestanden en het
            opdrachtformulier met de printspecificaties. De operator werkt
            altijd maar aan één opdracht tegelijk en doet dit in een afgesloten
            en beveiligde productieruimte. De documenten worden nauwkeurig
            gecontroleerd: ieder geprint exemplaar wordt gecontroleerd op
            leesbaarheid en volledigheid.
          </p>
        </div>
        <div class="col text">
          <h2>Verzending van een secured printing document</h2>
          <p>
            Zodra het document is geprint en voor de laatste keer is
            gecontroleerd, wordt het verpakt en bezorgd. Hoe dit wordt gedaan,
            is afhankelijk van het type document. Documenten met uiterst
            gevoelige informatie worden verzonden in een verzegelde verpakking,
            die in een kist met hangsloten met een cijfercombinatie wordt
            gestopt. Deze cijfercombinatie wordt door de secured operator via
            sms aan een geautoriseerde ontvanger van uw bedrijf doorgegeven.
          </p>
          <p>
            De kisten blijven in de secured printing ruimte totdat de Rijnja
            koerier ze meeneemt voor de bezorging. Op de dag van levering wordt
            de kist door de secured operator aan de koerier overgedragen. De
            koerier is een vaste medewerker van Rijnja.
          </p>
        </div>
        <div class="col text">
          <h2>Levering van een secured printing document</h2>
          <p>
            Voor de levering wordt met de geautoriseerde medewerker een
            bezorgafspraak gemaakt, die ook per mail wordt bevestigd. De koerier
            beschikt over een mobiel apparaat met daarop de speciaal voor ons
            ontwikkelde track-and-trace app “RijnjaGo”. Via deze app is
            inzichtelijk waar de koerier is en kunnen wij het verloop van het
            transport volgen tot en met het moment van bezorging. De koerier
            meldt zich bij aankomst op de gewenste locatie en overhandigt de
            bestelling. De ontvanger tekent voor ontvangst in RijnjaGo, waarna
            zowel uw bedrijf als ons orderbegeleidingssysteem direct bericht
            ontvangt dat de bestelling is afgeleverd.
          </p>
          <p>
            Ook documenten die persoonsgegevens bevatten, maar niet verzegeld
            hoeven te worden, dragen wij 1 op 1 over aan de postbezorger. Denk
            daarbij bijvoorbeeld aan AVG-gevoelige documenten, zoals brieven van
            overheidsorganisaties die persoonsgegevens van bewoners bevatten.
          </p>
        </div>
      </section>

      <section class="row reverse">
        <div class="col text">
          <h1>Beveiligde kopieeropdrachten</h1>
          <p>
            Ook wanneer het om fysieke kopieeropdrachten gaat, zorgt Rijnja
            ervoor dat alles veilig wordt geregeld. Kopieeropdrachten worden net
            als printopdrachten aangemeld via het bestelportal op onze website.
            Wij zorgen er vervolgens voor dat er op uw locatie transportkisten
            en hangsloten met cijfercombinatie aanwezig zijn om de te kopiëren
            stukken in op te bergen. De cijfercombinatie van deze sloten kan de
            besteller via een sms doorgeven aan onze secured operator.
          </p>
          <p>
            De kisten worden op het afgesproken moment opgehaald door een van
            onze koeriers, die geen toegang heeft tot de inhoud van de kisten.
            De kisten worden op de Rijnja locatie overgedragen aan de secured
            operator, die ze in een afgesloten kast bewaart in de secured
            printing ruimte. De secured operator zal de opdracht vervolgens
            verwerken en weer zoals vereist verpakken en klaarmaken voor
            bezorging.
          </p>
        </div>
        <div class="col image">
          <img class="kopieren" src="@/images/pages/secured-kopieren.svg" />
        </div>
      </section>
      <section class="row">
        <div class="col text">
          <h1>Voor wie is secured printing bedoeld?</h1>
          <p>
            Secured printing is er voor alle organisaties die te maken hebben
            met documenten die gevoelige of vertrouwelijke informatie bevatten.
            U kunt daarbij denken aan documenten die persoonsgegevens bevatten,
            zoals brieven die vanuit de overheid naar inwoners worden verzonden.
            Maar ook het werk van ambassades, vertrouwelijke stukken van
            overheden en raden van bestuur van grote (beursgenoteerde)
            ondernemingen, advocatenkantoren of woningbouwcorporaties komen bij
            ons terecht.
          </p>
        </div>
        <div class="col image">
          <img class="documents" src="@/images/pages/secured-documents.svg" />
        </div>
      </section>
      <div class="anchor-tag" id="contact"></div>
      <section class="row" id="">
        <div class="col-single">
          <h1>Meer weten over secured printing?</h1>
          <p>
            Wilt u meer weten over beveiligd printen en wat Koninklijke Rijnja
            hierin voor u kan betekenen?<br />Neem dan contact met ons op via
            onderstaand formulier.
          </p>
          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag secured printing"
            conversion-id="-wn3COivhJwYEKDetesD"
          ></contact-form>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
export default {
  components: { SiteFooter, ContactForm }
}
</script>

<style lang="scss" scoped>
.row.stappen {
  padding-bottom: 0;
  padding-top: 0;
}

.security {
  max-width: 425px;
}

.kopieren {
  max-width: 400px;
}

.documents {
  max-width: 220px;
}

.form {
  margin: 20px 0;
}

.top-button {
  margin-bottom: 35px;
}
</style>
